import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import {
  intentIsNotEmptyValueValidation
} from '@/services/autogenerated/validation.service'

export const autogeneratedValidationMixin = {
  mixins: [validationMixin],

  validations: {
    dataToAct: {
      $each: {
        application: {
          required
        },
        text: {
          required
        },
        intent: {
          required,
          intentIsNotEmpty: intentIsNotEmptyValueValidation
        }
      }
    }
  },

  watch: {
    dataToAct: {
      handler (value) {
        console.log('watch dataToAct: ', value)
      },
      deep: true
    }

  }
}
